import React, { Component } from "react";
import styles from "../PricingWrapper.module.scss";
import AppliedPricing from "../../../../shared/appliedPricing/AppliedPricing";
import Button from "@material-ui/core/Button";
import { withTranslation } from "react-i18next";
import vehiclesStyles from "../nscVehicles/NscVehicles.module.scss";
import PricingDetails from "../pricingDetails/PricingDetails";
import HasPermissionTo from "../../../../common/HasPermissionTo";
import { GPRS_ERROR_MESSAGE } from "../../../../common/Constants";

class DealerVehicles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditEnabled: null,
    };

    this.updateEditFlag = this.updateEditFlag.bind(this);
    this.handlePricingData = this.handlePricingData.bind(true);
  }

  handlePricingData(data) {
    this.props.updatePricingData(data);
  }

  updateEditFlag(value) {
    if (value !== null) {
      this.setState({ isEditEnabled: value });
    }
  }

  navigateToOptions(e) {
    this.props.handleTabChange(e, 2);
  }

  render() {
    return this.props.pricingData && this.props.pricingData.length > 0 ? (
      <>
        <PricingDetails
          {...this.props}
          isDealer={true}
          handlePricingData={this.handlePricingData}
          updateEditFlag={this.updateEditFlag}
          isEditEnabled={this.state.isEditEnabled}
          released={this.props.released}
          editChecked={this.props.editChecked}
          rowEditSaved={this.props.rowEditSaved}
          rowEditedCheckbox={this.props.rowEditedCheckbox}
          newlyReleased={this.props.newlyReleased}
        />
        <div className={styles.actionSection}>
          {this.props.released &&
          !this.props.priceUpdatesAvailable &&
          !this.props.pendingActionExist &&
          !this.props.buttonEnabled ? (
            <div>
              {this.props.rowEditSaved ? (
                <div className={styles.appliedPricing}>
                  <AppliedPricing />
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            <HasPermissionTo
              permissions={this.props.user.permissions.rolePermissions}
              perform={["vehiclePricing:view"]}
              render={() => (
                <Button
                  data-testid="applyPricesBtn"
                  variant="contained"
                  disabled={
                    this.state.isEditEnabled === true ||
                    this.props.user.readOnly
                  }
                  onClick={(event) => {
                    this.navigateToOptions(event, 1);
                  }}
                  className={vehiclesStyles.applyBtn}
                  component="button"
                >
                  <span>{this.props.t("DealerVehicles.next")}</span>
                </Button>
              )}
            />
          )}
        </div>
      </>
    ) : this.props.errorMessage === GPRS_ERROR_MESSAGE ? (
      <span className={styles.dataNotFound}>
        {this.props.t("Error.dataNotFoundFromSource")}
      </span>
    ) : (
      <span className={styles.dataNotFound}>
        {this.props.t("Error.dataNotFound")}
      </span>
    );
  }
}

export default withTranslation("emp")(DealerVehicles);
